// @flow

import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  pre: {
    overflow: 'auto',
    maxHeight: '300px',
    width: '100%',
    'background-color': theme.palette.background.default,
    border: 'solid 1px',
    'border-color': theme.palette.divider,
    padding: theme.spacing(2),
    'line-height': '1rem',
  },
}))

type Props = {
  children: React.Node,
}

function Pre({ children }: Props) {
  const classes = useStyles()
  return <pre className={classes.pre}>{children}</pre>
}

export default React.memo<Props>(Pre)
